import React, { useEffect, useRef, useState } from 'react';
import './styles.scoped.scss';
import JSONPretty from 'react-json-pretty';
import { FaExpand, FaFileAlt, FaRegPaperPlane, FaRegCopy } from 'react-icons/fa';
import clipboardCopy from 'clipboard-copy';
import ModalResponse from './ModalResponse';
import Loader from '../../../../Loader';
import { notification } from '../../../../../assets/constants/strings';
const JSONPrettyMon = require('react-json-pretty/dist/monikai');

/**
 * Response panel: pinned meta/status + header rows; ONLY the JSON body
 * scrolls, so the title and actions stay put.
 */
const ResponseDisplay = ({ responseData, responseHeaders, meta, loading }) => {
  const [show, setShow] = useState(false);
  const panelRef = useRef(null);

  // Bring the panel into view when a request fires, so the user sees the
  // loading state and then the response without hunting below the fold.
  useEffect(() => {
    if (loading && panelRef.current) {
      panelRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [loading]);

  const copyResponse = () => {
    clipboardCopy(JSON.stringify(responseData, null, 2))
      .then(() => notification('success', 'Response copied to clipboard.'))
      .catch(() => notification('info', 'Could not copy the response.'));
  };

  const body = loading ? (
    <div className='response-loading'>
      <Loader card />
    </div>
  ) : responseData == null ? (
    <div className='response-empty'>
      <FaRegPaperPlane size={28} />
      <p className='mb-0 mt-2'>
        Pick an endpoint and hit <b>Send</b> — the JSON response will show up
        here.
      </p>
    </div>
  ) : (
    <JSONPretty
      data={responseData}
      theme={JSONPrettyMon}
      className='customJSON'
    ></JSONPretty>
  );

  return (
    <>
      <div className='wf-response-display w-100' ref={panelRef}>
        {!loading && meta && (
          <div className='response-meta'>
            <span
              className={`response-meta__status ${
                meta.ok ? 'is-ok' : 'is-fail'
              }`}
            >
              {meta.ok ? 'Success' : 'Failed'}
            </span>
            <code className='response-meta__url'>
              {meta.method} {meta.url}
            </code>
            <span className='response-meta__time'>{meta.durationMs} ms</span>
            {!meta.ok && meta.message && meta.message !== 'Request failed' && (
              <span className='response-meta__message'>{meta.message}</span>
            )}
          </div>
        )}
        <div className='response-header'>
          <div className='response-header__title'>
            <FaFileAlt />
            <span>Response</span>
          </div>
          {/* Actions only make sense once there's a response. */}
          {!loading && responseData != null && (
            <div className='response-header__actions'>
              <button
                type='button'
                className='response-header__act'
                title='Copy response'
                onClick={copyResponse}
              >
                <FaRegCopy />
              </button>
              <button
                type='button'
                className='response-header__act'
                title='Expand response'
                onClick={() => setShow(true)}
              >
                <FaExpand />
              </button>
            </div>
          )}
        </div>
        <div className='response-body'>{body}</div>
      </div>

      <ModalResponse
        show={show}
        handleClose={() => setShow(false)}
        responseData={responseData}
        meta={meta}
      />
    </>
  );
};

export default ResponseDisplay;
